var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-home-page dashboard-page" },
    [
      _c("header4IQ", { attrs: { fromapp: "ug" } }),
      _vm._v(" "),
      _vm.showSnackbar
        ? _c("Snackbar", {
            attrs: {
              snackbarColor: _vm.snackbarColor,
              snackbarMessage: _vm.snackbarMessage
            },
            on: {
              close: function($event) {
                return _vm.closeSnackbar()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("AdvancedSearch", {
        attrs: { enablePopup: _vm.advancedSearchPopUp },
        on: {
          togglepopup: function(val) {
            return (_vm.advancedSearchPopUp = val)
          }
        }
      }),
      _vm._v(" "),
      !_vm.advancedSearchPopUp
        ? _c(
            "main",
            { staticClass: "main-container" },
            [
              _c(
                "section",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "grid-list-lg": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "apps_and_users_tool_bar",
                              attrs: { xl12: "" }
                            },
                            [
                              _c(
                                "v-toolbar",
                                {
                                  staticStyle: { color: "indigo" },
                                  attrs: {
                                    dense: "",
                                    flat: "",
                                    color: "#EFEFEF"
                                  }
                                },
                                [
                                  _c(
                                    "v-btn-toggle",
                                    {
                                      staticClass: "apps_and_users_buttons",
                                      attrs: { borderless: "", mandatory: "" },
                                      model: {
                                        value: _vm.page,
                                        callback: function($$v) {
                                          _vm.page = $$v
                                        },
                                        expression: "page"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.isSuperAdmin ||
                                                _vm.isSuperUser,
                                              expression:
                                                "isSuperAdmin || isSuperUser"
                                            }
                                          ],
                                          attrs: { value: "tenants" }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "hidden-sm-and-down"
                                            },
                                            [_vm._v("Tenants")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.isTenantAdmin ||
                                                _vm.isSuperAdmin ||
                                                _vm.isSuperUser,
                                              expression:
                                                "isTenantAdmin || isSuperAdmin || isSuperUser"
                                            }
                                          ],
                                          attrs: { value: "apps" }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "hidden-sm-and-down"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.tenantInfo.app_label ||
                                                    "Apps"
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        { attrs: { value: "users" } },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "hidden-sm-and-down"
                                            },
                                            [
                                              _vm._v(
                                                "Users ( " +
                                                  _vm._s(
                                                    _vm.getUsersData.filter(
                                                      function(item) {
                                                        return _vm.enableAdvancedSearch
                                                          ? _vm.tenantSeperatedDetails[
                                                              _vm.tenantInfo[
                                                                "schema_name"
                                                              ]
                                                            ].user_id.includes(
                                                              item.pk
                                                            )
                                                          : true
                                                      }
                                                    ).length
                                                  ) +
                                                  " )"
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            title: "Search",
                                            id: "enableUsersSearch"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.enableSearch = true
                                            }
                                          }
                                        },
                                        [_vm._v("search")]
                                      ),
                                      _vm._v(" "),
                                      _vm.enableSearch
                                        ? _c("v-text-field", {
                                            attrs: {
                                              label: "Search",
                                              "append-icon": "clear",
                                              id: "closeUsersSearch",
                                              autofocus: ""
                                            },
                                            on: {
                                              "click:append": function($event) {
                                                _vm.enableSearch = false
                                                _vm.searchText = ""
                                              }
                                            },
                                            model: {
                                              value: _vm.searchText,
                                              callback: function($$v) {
                                                _vm.searchText = $$v
                                              },
                                              expression: "searchText"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.isSuperAdmin,
                                          expression: "isSuperAdmin"
                                        }
                                      ],
                                      staticStyle: { display: "flex" }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            title: "Advanced Search",
                                            id: "enableSearch",
                                            color: _vm.enableAdvancedSearch
                                              ? "#e34d25 !important"
                                              : ""
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.advancedSearchPopUp = !_vm.advancedSearchPopUp
                                            }
                                          }
                                        },
                                        [_vm._v("zoom_in")]
                                      ),
                                      _vm._v(
                                        "    \n                            "
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.isSuperAdmin || _vm.isSuperUser,
                                          expression:
                                            "isSuperAdmin || isSuperUser"
                                        }
                                      ],
                                      attrs: { title: "Notes" }
                                    },
                                    [
                                      _c(
                                        "i",
                                        {
                                          staticClass: "material-icons",
                                          attrs: { id: "showNotes" },
                                          on: {
                                            click: function($event) {
                                              return _vm.showNotesPopup()
                                            }
                                          }
                                        },
                                        [_vm._v("note")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.isSuperAdmin ||
                                            _vm.isTenantAdmin,
                                          expression:
                                            "isSuperAdmin || isTenantAdmin"
                                        }
                                      ],
                                      attrs: { title: "Create User" }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: { id: "createUser" },
                                          on: {
                                            click: function($event) {
                                              return _vm.addNewUserPopup()
                                            }
                                          }
                                        },
                                        [_vm._v("add")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "companies" },
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "grid-list-lg": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        _vm._l(
                          _vm.getUsersData.filter(function(item) {
                            return _vm.enableAdvancedSearch
                              ? _vm.tenantSeperatedDetails[
                                  _vm.tenantInfo["schema_name"]
                                ].user_id.includes(item.pk)
                              : true
                          }),
                          function(user, index) {
                            return _c(
                              "v-flex",
                              { key: user.title, attrs: { lg3: "" } },
                              [
                                _c(
                                  "v-card",
                                  { attrs: { id: "usersCard" } },
                                  [
                                    _c(
                                      "v-layout",
                                      { staticClass: "tenant-card" },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "company-logo",
                                            attrs: {
                                              xs5: "",
                                              "overflow-hidden": ""
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _c("img", {
                                                staticClass: "logo-img",
                                                attrs: {
                                                  src: require("../../../common/assets/images/default-user-icon.png")
                                                }
                                              })
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "company-info",
                                            attrs: { xs7: "" }
                                          },
                                          [
                                            _c(
                                              "v-layout",
                                              { attrs: { row: "", wrap: "" } },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs12: "" } },
                                                  [
                                                    _c(
                                                      "h6",
                                                      {
                                                        staticClass:
                                                          "company-name",
                                                        attrs: {
                                                          title: user.email
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(user.email)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-layout",
                                              {
                                                staticClass: "users_card-bottom"
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs5: "" } },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("brightness_auto")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          Object.values(
                                                            user.apps_information
                                                          ).length
                                                        ) + " Apps"
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs7: "" } },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("local_library")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          Object.values(
                                                            user.docs_information
                                                          ).length
                                                        ) + " Documents"
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-layout",
                                              { attrs: { row: "", wrap: "" } },
                                              [
                                                _c(
                                                  "v-flex",
                                                  {
                                                    staticClass: "refresh-date",
                                                    attrs: { xs12: "" }
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("schedule")
                                                    ]),
                                                    _vm._v(
                                                      " \n                                            "
                                                    ),
                                                    _c("span", {
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.formateDate(
                                                            user.date_joined
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-divider", {
                                      staticClass: "purple darken-3"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-actions",
                                      [
                                        _c("h3", {
                                          staticClass: "company-name",
                                          attrs: { title: user.username },
                                          domProps: {
                                            textContent: _vm._s(user.username)
                                          }
                                        }),
                                        _vm._v(
                                          " \n                                "
                                        ),
                                        user.tenant_admin
                                          ? _c(
                                              "v-icon",
                                              {
                                                attrs: { title: "Tenant Admin" }
                                              },
                                              [_vm._v("group")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        user.user_type != "non_sso"
                                          ? _c(
                                              "v-icon",
                                              {
                                                staticClass: "ml-2",
                                                attrs: {
                                                  title:
                                                    "Single Sign-On enabled"
                                                }
                                              },
                                              [_vm._v("loop")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("v-spacer"),
                                        _vm._v(" "),
                                        _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              transition: "scale-transition",
                                              "close-on-content-click": false,
                                              "offset-x": "",
                                              right: ""
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    return [
                                                      !_vm.isSuperUser
                                                        ? _c(
                                                            "v-btn",
                                                            _vm._g(
                                                              {
                                                                attrs: {
                                                                  slot:
                                                                    "activator",
                                                                  icon: "",
                                                                  color: "grey"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.editableUserIndex = index
                                                                  }
                                                                },
                                                                slot:
                                                                  "activator"
                                                              },
                                                              on
                                                            ),
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v(
                                                                  "more_vert"
                                                                )
                                                              ])
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(" "),
                                            _c(
                                              "v-list",
                                              [
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.editUser(
                                                          user,
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        "\n                                                Edit\n                                            "
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                !(
                                                  user.email ==
                                                    _vm.loginEmail &&
                                                  user.user_role &&
                                                  _vm.loginSchemaName ==
                                                    user.current_schema[
                                                      "schema_name"
                                                    ]
                                                )
                                                  ? _c(
                                                      "v-list-item",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.addUserasTenantAdmin(
                                                              user,
                                                              index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        !user.tenant_admin
                                                          ? _c(
                                                              "v-list-item-title",
                                                              [
                                                                _vm._v(
                                                                  "\n                                                Enable Tenant Admin\n                                            "
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "v-list-item-title",
                                                              [
                                                                _vm._v(
                                                                  "\n                                                Disable Tenant Admin\n                                            "
                                                                )
                                                              ]
                                                            )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("v-divider"),
                                                _vm._v(" "),
                                                (user.user_type == "sso") &
                                                !_vm.makeUserHybrid
                                                  ? _c(
                                                      "v-list-item",
                                                      {
                                                        class: user.email
                                                          ? ""
                                                          : "disabled",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.resendEmail(
                                                              user,
                                                              "uigCredentials"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              "\n                                                Enable UIG credentials\n                                            "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !["sso"].includes(
                                                  user.user_type
                                                )
                                                  ? _c(
                                                      "v-list-item",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.resendEmail(
                                                              user
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              "\n                                                Resend Welcome Email\n                                            "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !["sso"].includes(
                                                  user.user_type
                                                )
                                                  ? _c(
                                                      "v-list-item",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.isChangePassword = true
                                                            _vm.userInComponent = user
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              "\n                                                Change Password\n                                            "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                (_vm.tenantInfo &&
                                                  _vm.tenantInfo[
                                                    "2fa_enabled"
                                                  ]) ||
                                                _vm.isTenantAdmin
                                                  ? _c(
                                                      "v-list-item",
                                                      {
                                                        class: user[
                                                          "2fa_enabled"
                                                        ]
                                                          ? "enabled"
                                                          : "disabled",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.reset2FAConfirmation = true
                                                            _vm.userInComponent = user
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              "\n                                                Reset 2FA\n                                            "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("v-divider"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    class:
                                                      (_vm
                                                        .loggedInUserInformation[
                                                        "username"
                                                      ] == user["username"] &&
                                                        _vm
                                                          .loggedInTenantInformation[
                                                          "schema_name"
                                                        ] ==
                                                          user[
                                                            "current_schema"
                                                          ]["schema_name"]) ||
                                                      ["sso"].includes(
                                                        user.user_type
                                                      )
                                                        ? "disabled"
                                                        : "",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.deleteConfirmation = true
                                                        _vm.userInComponent = user
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        "\n                                                Delete\n                                            "
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }
                        ),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                [
                  _c(
                    "v-dialog",
                    {
                      staticClass: "show-info-popup",
                      attrs: { width: "60rem", persistent: "" },
                      model: {
                        value: _vm.enableNewUser,
                        callback: function($$v) {
                          _vm.enableNewUser = $$v
                        },
                        expression: "enableNewUser"
                      }
                    },
                    [
                      _c("v-card", { staticClass: "popup-card" }, [
                        _c(
                          "div",
                          { staticClass: "user_creation_popup_div" },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "pa-2 ma-2",
                                        attrs: { xs1: "" }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "logo-img",
                                          attrs: {
                                            src: require("../../../common/assets/images/default-user-icon.png"),
                                            id: "profile-img-tag"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "pa-1 ma-2 mt-4 pt-3",
                                        attrs: { xs10: "" }
                                      },
                                      [
                                        _c("h3", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.editableUserIndex == -1
                                                ? "Create user "
                                                : "Update user"
                                            )
                                          }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "pt-3 ma-2 pl-2",
                                        attrs: { xs3: "" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        Email *\n                                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs8: "" } },
                                      [
                                        _c(
                                          "v-form",
                                          {
                                            ref: "form",
                                            attrs: { "lazy-validation": "" },
                                            model: {
                                              value: _vm.valid,
                                              callback: function($$v) {
                                                _vm.valid = $$v
                                              },
                                              expression: "valid"
                                            }
                                          },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                id: "userEmail",
                                                rules: _vm.emailRules,
                                                label: "Email",
                                                required: ""
                                              },
                                              model: {
                                                value: _vm.newuser.email,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newuser,
                                                    "email",
                                                    $$v
                                                  )
                                                },
                                                expression: "newuser.email"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "pt-3 ma-2 pl-2",
                                        attrs: { xs3: "" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    User Name *\n                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs8: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            id: "userName",
                                            label: "User Name",
                                            required: ""
                                          },
                                          model: {
                                            value: _vm.newuser.username,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newuser,
                                                "username",
                                                $$v
                                              )
                                            },
                                            expression: "newuser.username"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "pt-3 ma-2 pl-2",
                                        attrs: { xs3: "" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    First Name \n                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs8: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            id: "userFirstName",
                                            label: "First Name"
                                          },
                                          model: {
                                            value: _vm.newuser.firstname,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newuser,
                                                "firstname",
                                                $$v
                                              )
                                            },
                                            expression: "newuser.firstname"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "pt-3 ma-2 pl-2",
                                        attrs: { xs3: "" }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "\n                                        Apps\n                                    "
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          xs8: "",
                                          "overflow-hidden": ""
                                        }
                                      },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            id: "appsListDropdown",
                                            items: _vm.updatedUiUsersAppList,
                                            label: "Apps",
                                            multiple: "",
                                            chips: ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "selection",
                                                fn: function(ref) {
                                                  var item = ref.item
                                                  var index = ref.index
                                                  return [
                                                    index === 0
                                                      ? _c("v-chip", [
                                                          _c("span", [
                                                            _vm._v(_vm._s(item))
                                                          ])
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    index === 0
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "grey--text"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                            (+" +
                                                                _vm._s(
                                                                  _vm
                                                                    .updatedUiSelectedAppsList
                                                                    .length - 1
                                                                ) +
                                                                " apps)\n                                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            1920954191
                                          ),
                                          model: {
                                            value:
                                              _vm.updatedUiSelectedAppsList,
                                            callback: function($$v) {
                                              _vm.updatedUiSelectedAppsList = $$v
                                            },
                                            expression:
                                              "updatedUiSelectedAppsList"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "pt-3 ma-2 pl-2",
                                        attrs: { xs3: "" }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "\n                                        Documents\n                                    "
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs8: "", fluid: "" } },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            id: "docsListDropdown",
                                            items:
                                              _vm.updatedUiTotalDocsListValues,
                                            label: "Documents",
                                            multiple: "",
                                            chips: ""
                                          },
                                          model: {
                                            value:
                                              _vm.updatedUiSelectedDocsList,
                                            callback: function($$v) {
                                              _vm.updatedUiSelectedDocsList = $$v
                                            },
                                            expression:
                                              "updatedUiSelectedDocsList"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.tenantInfo.schema_name == "public"
                                  ? _c(
                                      "fieldset",
                                      { staticClass: "mt-2 mb-5 pa-3 pr-0" },
                                      [
                                        _c("legend", [
                                          _vm._v("Access To Tenants")
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          { attrs: { row: "", wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "pt-5 ma-2 pl-2",
                                                attrs: { xs3: "" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        Tenant Filters/Groups\n                                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs8: "", fluid: "" } },
                                              [
                                                _c("v-autocomplete", {
                                                  attrs: {
                                                    id:
                                                      "selectTenantServerDropdown",
                                                    items: _vm.tenantGroupList,
                                                    "item-value": "field",
                                                    "item-text": "display_name",
                                                    label: "Select Server Type",
                                                    "search-input":
                                                      _vm.searchInput,
                                                    multiple: "",
                                                    chips: ""
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      _vm.searchInput = null
                                                    },
                                                    "update:searchInput": function(
                                                      $event
                                                    ) {
                                                      _vm.searchInput = $event
                                                    },
                                                    "update:search-input": function(
                                                      $event
                                                    ) {
                                                      _vm.searchInput = $event
                                                    },
                                                    focus: function($event) {
                                                      return _vm.onChange(
                                                        "tenantGrouping"
                                                      )
                                                    },
                                                    change: function($event) {
                                                      return _vm.selectAllTenants()
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newuser.servers_list,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newuser,
                                                        "servers_list",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newuser.servers_list"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          { attrs: { row: "", wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "pt-4 ma-2 pl-2",
                                                attrs: { xs3: "" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        Exclude Tenants\n                                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs8: "", fluid: "" } },
                                              [
                                                _c("v-autocomplete", {
                                                  attrs: {
                                                    id:
                                                      "excludeSpecificTenants",
                                                    items:
                                                      _vm.excludeTenantsList,
                                                    label: "Exclude Tenants",
                                                    "item-value": "id",
                                                    "item-text": "tenant_name",
                                                    "search-input":
                                                      _vm.searchInput,
                                                    multiple: "",
                                                    chips: ""
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      _vm.searchInput = null
                                                    },
                                                    "update:searchInput": function(
                                                      $event
                                                    ) {
                                                      _vm.searchInput = $event
                                                    },
                                                    "update:search-input": function(
                                                      $event
                                                    ) {
                                                      _vm.searchInput = $event
                                                    },
                                                    focus: function($event) {
                                                      return _vm.onChange(
                                                        "excludeTenant"
                                                      )
                                                    }
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "selection",
                                                        fn: function(ref) {
                                                          var item = ref.item
                                                          var index = ref.index
                                                          return [
                                                            index <= 3
                                                              ? _c("v-chip", [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.tenant_name
                                                                      )
                                                                    )
                                                                  ])
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            index === 4
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "grey--text text-caption"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                    (+" +
                                                                        _vm._s(
                                                                          _vm
                                                                            .newuser
                                                                            .exclude_tenants
                                                                            .length -
                                                                            4
                                                                        ) +
                                                                        " more)\n                                                    "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    684364903
                                                  ),
                                                  model: {
                                                    value:
                                                      _vm.newuser
                                                        .exclude_tenants,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newuser,
                                                        "exclude_tenants",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newuser.exclude_tenants"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          { attrs: { row: "", wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "pt-3 ma-2 pl-2",
                                                attrs: { xs3: "" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        Include Tenants\n                                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs8: "", fluid: "" } },
                                              [
                                                _c("v-autocomplete", {
                                                  attrs: {
                                                    id: "includelists",
                                                    items: _vm.includeTenants,
                                                    label: "TenantLists",
                                                    "item-value": "id",
                                                    "item-text": "tenant_name",
                                                    "search-input":
                                                      _vm.searchInput,
                                                    multiple: "",
                                                    chips: ""
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      _vm.searchInput = null
                                                    },
                                                    "update:searchInput": function(
                                                      $event
                                                    ) {
                                                      _vm.searchInput = $event
                                                    },
                                                    "update:search-input": function(
                                                      $event
                                                    ) {
                                                      _vm.searchInput = $event
                                                    },
                                                    focus: function($event) {
                                                      return _vm.onChange(
                                                        "includeTenant"
                                                      )
                                                    }
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "selection",
                                                        fn: function(ref) {
                                                          var item = ref.item
                                                          var index = ref.index
                                                          return [
                                                            index <= 3
                                                              ? _c("v-chip", [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.tenant_name
                                                                      )
                                                                    )
                                                                  ])
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            index === 4
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "grey--text text-caption"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                (+" +
                                                                        _vm._s(
                                                                          _vm
                                                                            .newuser
                                                                            .include_tenants
                                                                            .length -
                                                                            4
                                                                        ) +
                                                                        " others)\n                                                "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    3158535551
                                                  ),
                                                  model: {
                                                    value:
                                                      _vm.newuser
                                                        .include_tenants,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newuser,
                                                        "include_tenants",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newuser.include_tenants"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.tenantInfo.schema_name == "public"
                                  ? _c(
                                      "v-layout",
                                      { attrs: { row: "", wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "pt-3 ma-2 pl-2",
                                            attrs: { xs3: "" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    User Roles\n                                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs8: "", fluid: "" } },
                                          [
                                            _c(
                                              "v-radio-group",
                                              {
                                                attrs: { row: "" },
                                                model: {
                                                  value:
                                                    _vm.newuser
                                                      .selectedUserRole,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newuser,
                                                      "selectedUserRole",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newuser.selectedUserRole"
                                                }
                                              },
                                              _vm._l(
                                                _vm.userRolesList,
                                                function(roletype, index) {
                                                  return _c("v-radio", {
                                                    key: index,
                                                    attrs: {
                                                      label: roletype.label,
                                                      value: roletype.value,
                                                      color: "indigo"
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.tenantInfo.schema_name == "public" &&
                                _vm.newuser.selectedUserRole != null
                                  ? _c(
                                      "v-layout",
                                      { attrs: { row: "", wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "pt-3 ma-2 pl-2",
                                            attrs: { xs3: "" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    App type roles\n                                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs8: "", fluid: "" } },
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                items: _vm.appTypeRolesList,
                                                label: "App type roles",
                                                multiple: "",
                                                chips: ""
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "selection",
                                                    fn: function(ref) {
                                                      var item = ref.item
                                                      var index = ref.index
                                                      return [
                                                        index <= 3
                                                          ? _c("v-chip", [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(item)
                                                                )
                                                              ])
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        index === 4
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "grey--text text-caption"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                (+" +
                                                                    _vm._s(
                                                                      _vm
                                                                        .newuser
                                                                        .selected_app_type_roles
                                                                        .length -
                                                                        4
                                                                    ) +
                                                                    " more)\n                                                "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                3098611475
                                              ),
                                              model: {
                                                value:
                                                  _vm.newuser
                                                    .selected_app_type_roles,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newuser,
                                                    "selected_app_type_roles",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newuser.selected_app_type_roles"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass:
                                      "pa-2 ma-3 pt-2 save_in_app_creation",
                                    attrs: { xs12: "" }
                                  },
                                  [
                                    _c("v-spacer"),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-2",
                                        attrs: {
                                          depressed: "",
                                          color: "grey lighten-3",
                                          id: "cancelEdit"
                                        },
                                        on: { click: _vm.cancelEdit }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    cancel\n                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class: _vm.disableActionBtn
                                          ? "disabled"
                                          : ""
                                      },
                                      [
                                        _c("v-btn", {
                                          staticClass: "ma-2",
                                          class:
                                            _vm.validateUserEmail &&
                                            _vm.validateUserEmail !=
                                              "Not a valid E-mail" &&
                                            _vm.newuser.username
                                              ? "enable"
                                              : "disabled",
                                          attrs: {
                                            depressed: "",
                                            color: "grey lighten-3",
                                            id: "userActionBtn",
                                            tabindex: "-1"
                                          },
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.editableUserIndex == -1
                                                ? "create"
                                                : "update"
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.addNewUser(
                                                _vm.newuser.email,
                                                null,
                                                "save"
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.isChangePassword
                ? _c("changePasswordPopupVue", {
                    attrs: {
                      fromheader: false,
                      userID: _vm.userInComponent.pk,
                      schemaName: _vm.tenantInfo.schema_name,
                      dialogStatus: _vm.isChangePassword
                    },
                    on: {
                      close: function($event) {
                        return _vm.closeChangePasswordPopup()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.deleteConfirmation || _vm.reset2FAConfirmation
                ? _c("confirmationPopupVue", {
                    attrs: {
                      confirmationTitle: _vm.deleteConfirmation
                        ? "Delete User"
                        : "Reset 2FA",
                      name: _vm.userInComponent.username,
                      confirmationText: _vm.deleteConfirmation
                        ? "delete user"
                        : "reset 2FA for user"
                    },
                    on: {
                      action: function($event) {
                        _vm.deleteConfirmation
                          ? _vm.deleteUser(_vm.userInComponent)
                          : _vm.reset2FA(_vm.userInComponent)
                      },
                      close: function($event) {
                        return _vm.closeConfirmationPopUP()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.notesPopup
                ? _c("NotesComponent", {
                    attrs: { notesInfo: _vm.notesInfo },
                    on: {
                      close: function($event) {
                        return _vm.closeNotes()
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }